module.exports = __webpack_public_path__ + "static/media/flight_white_24dp.53549d9f.svg";